import format from '@/common/format';

function guessFieldType(val) {
    if (Array.isArray(val)) {
        return 'array';
    }
    if (typeof val === 'string') {
        if (/^\d{4}-\d{2}-\d{2}/.test(val)) {
            return 'datetime';
        }
    }
    return typeof val;
}

function formatCustomFieldValue(value, type) {
    switch (type) {
        case 'datetime':
            return format.dateTime(value);
        case 'date':
            return format.dateLocal(value);
        case 'boolean':
            return format.yesNo(value);
        case 'array':
            return value.join(', ');
        case 'monetary':
            return format.monetize(value.amount, value.currency);
        default:
            return String(value);
    }
}

export default {
    methods: {
        getCustomFieldsTypes(schema) {
            if (!schema || schema.length <= 0) {
                return {};
            }

            return schema.reduce((map, item) => {
                map[item.fields.name] = item.fields.type;
                return map;
            }, {});
        },
        getCustomFields(resource, types) {
            if (this[resource].customFields) {
                return Object
                    .keys(this[resource].customFields)
                    .map((name) => {
                        const value = this[resource].customFields[name];
                        const type = types[name] ? types[name] : guessFieldType(value);
                        const calculatedValue = formatCustomFieldValue(value, type);
                        return {
                            name,
                            type,
                            value: calculatedValue,
                        };
                    });
            }
            return [];
        },
    },
};
